const DISABLE_LOGGING = true;


export function logMethodCall() {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        if (DISABLE_LOGGING) {
            return descriptor;
        }

        const callCounts: Record<string, number> = {};

        const originalMethod = descriptor.value;
        descriptor.value = function (...args: any[]) {
            const logs: any[] = []; // Array für gemischte Daten (Strings und Objekte)
            const log = (...messages: any[]) => logs.push(messages); // Akzeptiert jetzt beliebige Werte

            log(`...called with arguments:`, args);
            const key = `${propertyKey}(${JSON.stringify(args)})`;
            callCounts[key] = (callCounts[key] || 0) + 1;

            const printLogs = () => {
                console.group(`METHOD: <<${propertyKey}>>: ${callCounts[key]} calls`);
                logs.forEach(entry => {
                    if (typeof entry === 'string') {
                        console.log(entry); // Normale Logs
                    } else if (Array.isArray(entry)) {
                        if (entry[0].error) {
                            console.error('Error:', entry[0].error); // Fehler mit console.error ausgeben
                        } else {
                            console.log(...entry); // Loggruppe
                        }
                    } else {
                        console.dir(entry); // Interaktive Objektlogs
                    }
                });
                console.groupEnd()
            };

            try {
                const result = originalMethod.apply(this, args);

                // Falls das Ergebnis ein Signal ist, handle es als solches
                if (typeof result === 'function' && result.toString().includes('[Computed:')) {
                    const signalValue = result(); // Signal auswerten
                    log("... delivering response: ", signalValue);

                    if (signalValue.success === false) {
                        log({ error: signalValue.error });
                        printLogs();
                    }
                    log(`Exiting method: ${propertyKey}`);
                    printLogs();
                    return result; // Signal zurückgeben
                }
                // Falls das Ergebnis ein Promise ist, handle es als solches
                else if (result instanceof Promise) {
                    return result
                        .then((res: any) => {
                            log("... delivering response: ", res);
                            log(`Exiting method: ${propertyKey}`);
                            printLogs();
                            return res;
                        })
                        .catch((err: any) => {
                            log({ error: err });
                            printLogs();
                            throw err;
                        });
                }
                // Ansonsten einfach das Resultat der Methode loggen
                else {
                    log("... delivering response: ", result);
                    log(`Exiting method: ${propertyKey}`);
                    printLogs();
                    return result;
                }
            } catch (error) {
                log(`Error in method: ${propertyKey}`);
                log({ error });
                printLogs();
                throw error;
            }
        };

        return descriptor;
    };
}
